import { RenderLayer } from '@skand/three-js-renderer';
import { Color, Quaternion, SphereGeometry, TorusGeometry, Vector3 } from 'three';
import { generateArrowMesh, geometryToMesh } from './Utils';
import { Widget } from './Widget';
/**
 * Widget manager handles the creation and updating of widgets.
 */
export class WidgetManager {
    constructor(renderer, meshInstance, gestures) {
        Object.defineProperty(this, "renderer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meshInstance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gestures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.renderer = renderer;
        this.meshInstance = meshInstance;
        this.gestures = gestures;
    }
    /**
     * Helper method to create a new widget within this command
     */
    createWidget(batchable, path = null) {
        return new Widget(this.renderer, this.meshInstance, this.gestures, [batchable], path);
    }
    /**
     * Create a sphere-shaped widget
     */
    createSphereWidget(radius, color, path = null) {
        const mesh = geometryToMesh(this.renderer, new SphereGeometry(1));
        const batchable = {
            type: 'polygon',
            vertices: mesh.vertices,
            indices: mesh.indices,
            position: new Vector3(),
            rotation: new Quaternion(),
            colors: [color],
            scale: new Vector3(1, 1, 1),
            material: {
                type: 'basicOpaque',
                color: new Color(1, 1, 1),
            },
            renderLayer: RenderLayer.AfterPanorama,
            pixelSize: radius,
        };
        return this.createWidget(batchable, path);
    }
    /**
     * Create an arrow widget
     */
    createArrowWidget(length, color, path = null) {
        const mesh = generateArrowMesh(this.renderer, 1, 1 / 100);
        const batchable = {
            type: 'polygon',
            vertices: mesh.vertices,
            indices: mesh.indices,
            position: new Vector3(),
            rotation: new Quaternion(),
            colors: [color],
            scale: new Vector3(1, 1, 1),
            material: {
                type: 'basicOpaque',
                color: new Color(1, 1, 1),
            },
            renderLayer: RenderLayer.AfterPanorama,
            pixelSize: length,
        };
        return this.createWidget(batchable, path);
    }
    /**
     * Create a ring widget
     */
    createRingWidget(radius, color, path = null) {
        const mesh = geometryToMesh(this.renderer, new TorusGeometry(1, 1 / 100, 20, 36));
        const batchable = {
            type: 'polygon',
            vertices: mesh.vertices,
            indices: mesh.indices,
            position: new Vector3(),
            rotation: new Quaternion(),
            colors: [color],
            scale: new Vector3(1, 1, 1),
            material: {
                type: 'basicOpaque',
                color: new Color(1, 1, 1),
            },
            renderLayer: RenderLayer.AfterPanorama,
            pixelSize: radius,
        };
        return this.createWidget(batchable, path);
    }
}
